module.exports = __webpack_public_path__ + "img/img03.5cd6fa15.png";